<template>
  <div class="analyse">
    <div class="userinfo">
      <div class="brand_box">测评报告</div>
      <div class="tit">{{ name }}</div>
      <div class="desc">
        <span v-if="userInfo.realName">{{ userInfo.realName | protectionName }}</span>
        <span v-if="!userInfo.realName">{{ userInfo.userName | protectionName }}</span>
        <div>{{ finishTime | stringOut }}</div>
      </div>
    </div>
    <div class="content">
      <div class="box">
        <div class="cell whole">
          <van-cell title="整体概览">
            <template slot="label">
              <div class="top">
                <van-row type="flex" justify="space-around" align="center">
                  <van-col span="7">
                    <div class="circle" v-for="(item, index) in whole.difficulties" :key="index">
                      <van-circle
                        v-model="item.scoreRate"
                        layer-color="#DCDFE6"
                        :rate="item.scoreRate"
                        :speed="50"
                        color="#75eece"
                        :text="item.score"
                        :stroke-width="120"
                        :size="50"
                        v-if="item.key == 'easy'"
                      />
                      <van-circle
                        v-model="item.scoreRate"
                        layer-color="#DCDFE6"
                        :rate="item.scoreRate"
                        :speed="50"
                        color="#69b8fe"
                        :text="item.score"
                        :stroke-width="120"
                        :size="50"
                        v-if="item.key == 'medium'"
                      />
                      <van-circle
                        v-model="item.scoreRate"
                        layer-color="#DCDFE6"
                        :rate="item.scoreRate"
                        :speed="50"
                        color="#ffbe59"
                        :text="item.score"
                        :stroke-width="120"
                        :size="50"
                        v-if="item.key == 'hard'"
                      />
                      <div class="tit">{{ item.name }}题</div>
                    </div>
                  </van-col>
                  <van-col span="17">
                    <div class="circle big">
                      <van-circle
                        v-model="currentRate"
                        layer-color="#DCDFE6"
                        :rate="whole.score"
                        :speed="50"
                        :color="gradientColor"
                        :text="whole.scoreText"
                        :stroke-width="150"
                        :size="150"
                        style="margin-bottom:20px"
                      >
                        <template slot="default">
                          <div class="scoretext">
                            {{ whole.scoreText }}
                            <div class="desc">总得分</div>
                          </div>
                        </template>
                      </van-circle>

                      <div class="rinfo">
                        <van-row>
                          <van-col span="12">
                            <span class="kuai successbg"></span>
                            答对
                            {{ whole.questionCorrectCount }}题
                          </van-col>
                          <van-col span="12">
                            <span class="kuai dangerbg"></span>
                            答错
                            {{ whole.questionErrorCount }}题
                          </van-col>
                          <!-- <van-col span="8">
                            <span class="kuai infobg"></span>
                            无效
                            {{ whole.questionInvalidCount }}题
                          </van-col>-->
                        </van-row>
                      </div>
                    </div>
                    <div class="rinfo"></div>
                  </van-col>
                </van-row>
              </div>
              <van-divider>共测评 {{ tags.count }} 个知识点</van-divider>
              <div class="tagcount">
                <van-row>
                  <van-col span="8">
                    <p>已熟练掌握</p>
                    {{ tags.excellentCount }}个
                  </van-col>
                  <van-col span="8">
                    <p>基本熟练掌握</p>
                    {{ tags.averageCount }}个
                  </van-col>
                  <van-col span="8">
                    <p>未掌握</p>
                    {{ tags.badCount }}个
                  </van-col>
                </van-row>
              </div>
              <div class="wholeinfo">
                <div class="title">
                  您所在等级
                  <span>( 根据知识点熟练掌握情况评定 )</span>
                </div>
                <div class="progress">
                  <div class="sanyan" :style="{ left: whole.rankRate-5 + '%' }">
                    <img :src="stripHeadImg" />
                  </div>
                  <div class="strip">
                    <img :src="stripImg" />
                  </div>
                  <!-- <div class="nodebox">
                    <div
                      class="node"
                      v-for="(item, index) in whole.rankRange"
                      :key="index"
                      :style="{ left: item.rate - (40 - index * 10) + '%' }"
                    >{{ item.key }}</div>
                  </div> -->
                </div>
                <div class="infobox">
                  <p>您想了解自己的提升空间么？来测一测吧</p>
                  <van-button block color="#69b8fe" class="mtop" @click="show = true">我也要测评</van-button>
                </div>
              </div>
            </template>
          </van-cell>
        </div>
      </div>
    </div>
    <div class="content2">
      <div class="qrcode_box">
        <div class="qrcode">
          <div class="img">
            <img src="../../assets/qrcode.png" />
          </div>
          <div class="desc">识别二维码关注源思维公众号</div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom" closeable>
      <div class="panel">
        <div class="panel_box">
          <div class="tit">{{ name }}</div>
          <div class="desc">{{ planStandardTime | format }}</div>
          <div>
            <van-tag plain>{{ grade.name }}</van-tag>
            <van-tag plain>{{ subject.name }}</van-tag>
            <van-button size="small" @click="goUrl">马上测评</van-button>
          </div>
        </div>
      </div>
      <div class="but">
        <van-button hairline block @click="goIndex">更多测评</van-button>
      </div>
    </van-popup>
    <loadingPage :isShow="loading"></loadingPage>
  </div>
</template>
<script>
import { analyseApi } from '@/api/index'
import weixinshare from '@/wxsdk/share'
import loadingPage from '../loading'
export default {
  components: {
    loadingPage
  },
  data() {
    return {
      show: false,
      loading: true,
      currentRate: 0,
      gradientColor: {
        '0%': '#8dc2ff',
        '100%': '#7e7fff'
      },
      name: '',
      planStandardTime: '',
      spendTime: '',
      finishTime: '',
      whole: {
        score: 0,
        scoreText: '分',
        questionCorrectCount: 0,
        questionErrorCount: 0,
        questionInvalidCount: 0,
        difficulties: [],
        rankRange: [],
        rankRate: 0,
        rank:''
      },
      tags: {
        count: 0,
        averageCount: 0,
        badCount: 0,
        excellentCount: 0
      },
      grade: {},
      subject: {},
      planId: 0,
      examLogId: 0,
      userInfo: {
        realName: '',
        userName: ''
      }
    }
  },
  mounted() {
    this.planId = this.$route.params.sid
    this.examLogId = this.$route.params.eid
    this.getAnalyse()

    const linkurl = window.location.href
    weixinshare(this.$titles, linkurl, this.$imgurls, this.$descs)
  },
  methods: {
    getAnalyse() {
      let params = {
        planID: this.planId,
        examLogId: this.examLogId
      }
      analyseApi.getAnalyse(params).then(res => {
        this.loading = false
        this.name = res.data.name
        this.planStandardTime = res.data.planStandardTime
        this.spendTime = res.data.spendTime
        this.finishTime = res.data.finishTime

        this.whole.rank = res.data.rank
        this.whole.score = res.data.score
        this.userInfo = res.data.userInfo
        this.whole.scoreText = res.data.score + '分'
        this.whole.questionCorrectCount = res.data.questionCorrectCount
        this.whole.questionErrorCount = res.data.questionErrorCount
        this.whole.questionInvalidCount = res.data.questionInvalidCount
        let difficulties = res.data.difficulties.map(item => {
          item.score = item.score + '%'
          return item
        })
        this.whole.difficulties = difficulties
        this.whole.rankRange = res.data.rankRange
        this.whole.rankRate = res.data.rankRate
        this.tags.count = res.data.tags.count
        this.tags.averageCount = res.data.tags.averageCount
        this.tags.badCount = res.data.tags.badCount
        this.tags.excellentCount = res.data.tags.excellentCount
        this.subject = res.data.subject
        this.grade = res.data.grade
      })
    },
    goUrl() {
      this.$router.push({
        name: 'info',
        params: { id: this.planId }
      })
    },
    goIndex() {
      this.$router.push({
        name: 'home'
      })
    }
  },
  filters: {
    format: function(value) {
      let str = '最佳用时：'
      if (value > 60) {
        let i = parseInt(value / 60)
        let m = value - 60 * i
        return str + i + '分' + m + '秒'
      } else {
        return str + value + '秒'
      }
    },
    protectionName: function(name) {
      return [...name]
        .map((item, index, arr) => {
          return Math.floor(arr.length / 2) === index ? '*' : item
        })
        .join('')
    },
    stringOut: function(value) {
      return value.substr(0, 13) + '时'
    }
  },
  computed: {
    stripImg() {
      let img = ''
      if (this.whole.rank == 'A+') {
        img = require('../../assets/strip_a+.jpg')
      } else if (this.whole.rank == 'A') {
        img = require('../../assets/strip_a.jpg')
      } else if (this.whole.rank == 'B+') {
        img = require('../../assets/strip_b+.jpg')
      } else if (this.whole.rank == 'B') {
        img = require('../../assets/strip_b.jpg')
      } else {
        img = require('../../assets/strip_c.jpg')
      }
      return img
    },
    stripHeadImg() {
      let img = ''
      if (this.whole.rank == 'A+') {
        img = require('../../assets/strip_head_a+.jpg')
      } else if (this.whole.rank == 'A') {
        img = require('../../assets/strip_head_a.jpg')
      } else if (this.whole.rank == 'B+') {
        img = require('../../assets/strip_head_b+.jpg')
      } else if (this.whole.rank == 'B') {
        img = require('../../assets/strip_head_b.jpg')
      } else {
        img = require('../../assets/strip_head_c.jpg')
      }
      return img
    }
  }
}
</script>
<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
.analyse {
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  position: relative;
  padding-bottom: 15px;
  .text_r {
    text-align: right;
  }
  .success {
    color: #44d9b1;
  }
  .successbg {
    background-color: #44d9b1;
  }
  .warning {
    color: #e6a23c;
  }
  .danger {
    color: #ff4a4a;
  }
  .dangerbg {
    background-color: #ff4a4a;
  }
  .info {
    color: #909399;
  }
  .infobg {
    background-color: #909399;
  }
  .brand {
    color: #69b8fe;
  }
  .userinfo {
    padding: 10px 0;
    > div {
      padding: 0 16px;
    }
    color: #fff;
    // background: #69b8fe;
    background-image: linear-gradient(#45b5fb, #1cc5f0);
    font-size: 12px;
    line-height: 24px;
    min-height: 180px;
    border-radius: 0 0 20px 20px;
    .brand_box {
      height: 40px;
      background: #fedb5a;
      position: absolute;
      top: 65px;
      right: 28px;
      transform: rotate(-10deg);
      font-size: 16px;
      color: #fff;
      line-height: 30px;
    }
    .tit {
      font-size: 17px;
      margin-bottom: 8px;
      .van-icon {
        float: left;
        font-size: 28px;
      }
    }
    .r {
      float: right;
    }
  }
  .content {
    width: 94%;
    position: absolute;
    left: 3%;
    top: 95px;
    z-index: 99;
    min-height: 623px;
  }
  .content2 {
    width: 94%;
    margin: 523px auto 0;
  }
  .box {
    border-radius: 8px 8px 0 0;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    .top {
      padding-top: 15px;
      .circle {
        // position: absolute;
        z-index: 100;
        text-align: center;
        /deep/ .van-circle__text {
          font-size: 12px;
        }
        .tit {
          font-size: 12px;
          color: #303133;
          margin-bottom: 10px;
        }
      }
      .circle.big {
        /deep/ .van-circle__text {
          font-size: 24px;
        }
        .scoretext {
          font-size: 24px;
          color: #303133;
          margin-top: 60px;
          .desc {
            color: #606266;
            font-size: 12px;
            line-height: 32px;
          }
        }
      }
      .rinfo {
        font-size: 13px;
        color: #606266;
        line-height: 24px;
        .kuai {
          width: 7px;
          height: 7px;
          display: inline-block;
          margin-right: 3px;
        }
        .desc {
          font-size: 12px;
          color: #909399;
          text-align: right;
        }
      }
    }
    .whole {
      .tagcount {
        text-align: center;
        font-size: 17px;
        color: #303133;
        margin-bottom: 18px;
        p {
          font-size: 12px;
          color: #909399;
          margin: 0 0 8px;
        }
        .van-col + .van-col {
          border-left: 1px dotted #ebedf0;
        }
      }
      .wholeinfo {
        .title {
          font-size: 14px;
          color: #303133;
          margin-bottom: 8px;
          span {
            font-size: 12px;
            color: #606266;
          }
        }
        .progress {
          position: relative;
          padding-top: 35px;
          .sanyan {
            position: absolute;
            top: 2px;
            width: 10%;
            img {
              width: 100%;
            }
          }
          .strip {
            padding-top: 10px;
            position: relative;
            width: 100%;
            height: auto;
            background: none;
            img {
              width: 100%;
            }
          }
          .nodebox {
            margin-top: 8px;
            position: relative;
            height: 20px;
            font-size: 13px;
            .node {
              position: absolute;
            }
          }
        }
      }
    }
  }
  .cell {
    border-radius: 8px 8px 0 0;
    .van-cell {
      border-radius: 8px 8px 0 0;
    }
    background-color: #fff;
    margin-bottom: 10px;
    .mtop {
      margin-top: 12px;
    }
  }
  .van-popup {
    padding-top: 50px;
    .panel {
      width: 92%;
      margin: 0 auto;
      border-radius: 5px;
      background-image: linear-gradient(to bottom right, #e6a23c, #fedb5a);
      .panel_box {
        padding: 15px;
        .tit {
          font-size: 16px;
          color: #fff;
        }
        .desc {
          font-size: 12px;
          color: #eee;
          margin: 5px 0;
        }
        .van-tag {
          margin-right: 8px;
        }
        .van-button {
          float: right;
          margin-top: -5px;
        }
      }
    }
    .but {
      padding: 100px 12px 20px;
      .van-button--default {
        border-right: #fff;
        border-left: #fff;
      }
    }
  }
  .qrcode_box {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    padding: 0 30px 12px;
    font-size: 12px;
    color: #606266;
    .qrcode {
      padding-top: 20px;
      text-align: center;
      img {
        width: 70%;
      }
    }
  }
}
</style>
